import React, { Component } from 'react'
import { object } from 'prop-types'
import { connect } from 'react-redux'
import { Popup } from 'react-mapbox-gl'
import '../styles/popup.css'

class InfoBox extends Component {
  render() {
    return this.props.infobox.sign !== null &&
      this.props.infobox.type === 'regular' ? (
      <Popup
        className="popup-container"
        coordinates={this.props.infobox.sign.geometry.coordinates}
        offset={{
          'bottom-left': [12, -38],
          bottom: [0, -70],
          'bottom-right': [-12, -38],
        }}
      >
        <div className="marker-popup regular">
          <h3>{this.props.infobox.sign.properties.sign_description}</h3>
          <hr />
          <div>
            <p>
              <strong>
                {this.props.infobox.sign.properties.distance_from_intersection}{' '}
                Ft
              </strong>{' '}
              from{' '}
              <strong>{this.props.infobox.sign.properties.from_street}</strong>
            </p>
            <p>
              On the{' '}
              <strong>{this.props.infobox.sign.properties.sos_new[1]}</strong>{' '}
              of <strong>{this.props.infobox.sign.properties.on_street}</strong>
            </p>
            {this.props.infobox.sign.properties.arrow_points && (
              <p>
                Arrow points to the{' '}
                <strong>
                  {this.props.infobox.sign.properties.arrow_points}
                </strong>
              </p>
            )}
          </div>
        </div>
      </Popup>
    ) : null
  }
}

InfoBox.propTypes = {
  infobox: object.isRequired,
}

const mapStateToProps = ({ map }) => ({
  infobox: map.infobox,
})

export default connect(mapStateToProps)(InfoBox)



// WEBPACK FOOTER //
// ./src/components/Map/Markers/InfoBox.jsx